import { render, staticRenderFns } from "./CrmEditEmailEvent.vue?vue&type=template&id=fa02e1fc"
import script from "./CrmEditEmailEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEditEmailEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa02e1fc')) {
      api.createRecord('fa02e1fc', component.options)
    } else {
      api.reload('fa02e1fc', component.options)
    }
    module.hot.accept("./CrmEditEmailEvent.vue?vue&type=template&id=fa02e1fc", function () {
      api.rerender('fa02e1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/edit/CrmEditEmailEvent.vue"
export default component.exports